import { SUPPORTED_LANGUAGES } from '@/utils/constants';

type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * Normalize a user's saved language preference to a supported UI language.
 *
 * Lowercases and strips region subtags (e.g. "en-US" → "en"). Returns null
 * when the value is missing or not one of SUPPORTED_LANGUAGES.
 */
export function resolveLanguagePreference(
  raw: unknown,
): SupportedLanguage | null {
  if (typeof raw !== 'string') return null;
  const [base] = raw.toLowerCase().split('-');
  const isSupported = (v: string): v is SupportedLanguage =>
    (SUPPORTED_LANGUAGES as readonly string[]).includes(v);
  return base && isSupported(base) ? base : null;
}
